var render, staticRenderFns
import script from "./GrowthProgramMixin.vue?vue&type=script&lang=js&"
export * from "./GrowthProgramMixin.vue?vue&type=script&lang=js&"
import style0 from "./GrowthProgramMixin.vue?vue&type=style&index=0&id=3c091ffa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c091ffa",
  null
  
)

export default component.exports